module.exports = __webpack_public_path__ + "img/Mivivo_Logo_RZ_4c.jpg";